import { render, staticRenderFns } from "./AdminPasswordUpdate.vue?vue&type=template&id=4ddc6f19&scoped=true"
import script from "./AdminPasswordUpdate.vue?vue&type=script&lang=js"
export * from "./AdminPasswordUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ddc6f19",
  null
  
)

export default component.exports